import React from "react";

import {
	Standing,
} from "@data-types/sport-stats/SportStatsTypes";
import { TeamStandingRules } from "@features/offer/shared/statistics/components/team-standings";
import { observer } from "mobx-react";

import { TeamStandingsItem } from ".";
import { TeamStandingsHeader } from ".";
import TeamStandingsStatsStore from "@state/stores/offer/statistics/TeamStandingsStatsStore";

export const TeamStandingsBody = observer(
	({
		standings,
		groupName,
		store,
	}: {
		standings: Standing[] | undefined;
		groupName?: string;
		store: TeamStandingsStatsStore
	}) => {

		return (
			<>
				<div className="card card--sectioned card--raised card--stats">
					{groupName && (
						<div className="card--sectioned__header card--stats__header">
							<div className="card__title card__title--base card--stats__heading">
								{groupName}
							</div>
						</div>
					)}

					<div className="card--sectioned__body card--stats__body u-pad--reset">
						<div className="table--responsive">
							<table className="table table--borderless table--stand">
								<>
									<TeamStandingsHeader
										teamStandingsFilter={
											store.teamStandingsFilter
											? store.teamStandingsFilter
											: undefined
										}
									/>
									<tbody className="table__body table__body--borderless">
										{standings?.map((standing, index) => (
											<TeamStandingsItem
												key={index}
												standing={standing}
												store={store}
												homeScore={standing.liveScore?.homeScore}
												awayScore={standing.liveScore?.awayScore}
												isAwayTeam={standing.liveScore?.isAwayTeam}
											/>
										))}
									</tbody>
								</>
							</table>
						</div>
					</div>

					{groupName && (
						<div className="card--stats__body u-pad--top--2">
							<TeamStandingRules
								promotions={store.extractUniquePromotions(
									standings
								)}
							/>
						</div>
					)}
				</div>

				{!groupName && (
					<TeamStandingRules
						promotions={store.extractUniquePromotions(
							standings
						)}
					/>
				)}
			</>
		);
	}
);
